module.exports = __webpack_public_path__ + "3774e28fc3b626695df331b6449cd8dc.png";